import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { connect } from "react-redux";
import { Application } from "../..";
import { IAppState } from "../../../Common";
import AssignUsersToAppContainer from "./AssignUsersToAppContainer";

type Props = {
  selectedAppId: string;
};

type StateProps = {
  areAppsLoaded: boolean;
  app?: Application;
};

function mapStateToProps(state: IAppState, props: Props): StateProps {
  // let app;

  // if (state.app.appsLoadingState.isLoaded) {
  //   // get the app that matches the selected app
  //   let app =
  // }

  return {
    areAppsLoaded: state.app.appsLoadingState.isLoaded,
    app: state.app.applications.filter(a => a.rolePrefix === props.selectedAppId)[0]
  };
}

const AppSettings: React.FC<Props & StateProps> = props => (
  <Card>
    <CardHeader>{!!props.app && <h3>{props.app.name} Admin Settings</h3>}</CardHeader>
    <CardBody>
      {!!props.app && (
        <>
          <h3>Assign Managers</h3>
          <br />
          <AssignUsersToAppContainer application={props.app} />
        </>
      )}
    </CardBody>
  </Card>
);

export default connect(mapStateToProps)(AppSettings);
